import { render, staticRenderFns } from "./TaskAutoApprovedResubmissionBanner.vue?vue&type=template&id=1334009a"
import script from "./TaskAutoApprovedResubmissionBanner.vue?vue&type=script&lang=js"
export * from "./TaskAutoApprovedResubmissionBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports